import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { Animated } from "react-animated-css";
import { isEmpty } from "lodash";
import {
  commonApiCall,
  UNDERWRITING_DETAILS,
  getJwt,
} from "../../../redux/actions/index";
import {
  setProcessStep,
  getProcessStep,
  UnderWritingRoutes,
  showErrorToast,
  segmentTracking,
  getItem,
  removeItem,
} from "../../../utils/index";
import {
  API_URL_UNDERWRITING,
  CONSUMER_PORTAL_URL,
} from "../../../config/configs";

const MedicareEnroll = ({
  commonApiCall,
  underwriting,
  direct_link,
  company_information,
  t,
  ...props
}) => {
  // const { applicationId, applicationType, goalType, policyType } = underwriting;
  const [formData, setFormData] = useState({
    applicationId: underwriting?.applicationId,
    applicationType: underwriting?.applicationType
      ? underwriting?.applicationType
      : "Web",
    medicarePolicyFlag: null,
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const checkDefault = () => {
    const validDirectLinks = ["/medicare"];
    const validDefaultPages = ["medicare"];
    if (
      validDirectLinks.includes(direct_link) ||
      validDefaultPages.includes(company_information?.defaultPage)
    ) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    async function doSubmit() {
      try {
        const { medicarePolicyFlag } = formData;
        if (medicarePolicyFlag) {
          const splitpath = window.location.pathname.split("/");
          const request = {
            applicationId: underwriting?.applicationId,
            applicationType: underwriting?.applicationType,
            goalType: underwriting?.goalType,
            medicarePolicyFlag: JSON.parse(medicarePolicyFlag),
            resumeProcess: setProcessStep(
              splitpath[1],
              underwriting?.policyType,
              underwriting?.goalType
            ),
          };

          if (underwriting?.goalType === "MEDICARE")
            request.policyType = "MEDICARE_INSURANCE";
          const isAuthorized = getJwt() ? true : false;
          const apiEndPoint = API_URL_UNDERWRITING + "saveUnderWriting";
          const response = await commonApiCall(
            apiEndPoint,
            "post",
            request,
            UNDERWRITING_DETAILS,
            isAuthorized
          );
          if (response.status.code === 200) {
            const eventObject = {
              agent_id: response?.data?.agentDetail?.agentId,
              application_id: underwriting?.applicationId,
              param_name: "medicarePolicyFlag",
              param_value: response.data.medicarePolicyFlag,
            };
            segmentTracking("application_set_param", eventObject);
            props.history.push(UnderWritingRoutes.YOUR_GENDER);
          } else {
            showErrorToast(response.status.message);
          }
        }
      } catch (err) {
        showErrorToast(t("validation_message.SOMETHING_WENT_WRONG"));
      }
    }
    doSubmit();
  }, [formData]);

  const saveUnderwriting = async (type) => {
    const { applicationType } = formData;
    const splitpath = window.location.pathname.split("/");
    const domainNamePath = window.location.hostname;
    const referenceFromUrl = getItem("referenceFromUrl");
    let eventPage;
    const request = {
      goalType: type,
      applicationId: "",
      applicationType: applicationType,
      referalCode: company_information?.refferalCode,
      // referenceLocation: await encryptme(address),
      resumeProcess: setProcessStep(splitpath[1], "", type, null),
      reference: referenceFromUrl
        ? referenceFromUrl
        : underwriting?.reference
        ? underwriting?.reference
        : domainNamePath,
    };
    if (
      (company_information?.defaultPage === "medicare" &&
        direct_link !== "/permanent" &&
        direct_link !== "/term" &&
        direct_link !== "/dividend" &&
        direct_link !== "/index") ||
      direct_link === "/medicare"
    ) {
      request.policyType = "MEDICARE_INSURANCE";
      eventPage = "Coverage Page - Medicare Only";
    }

    const isAuthorized = getJwt() ? true : false;
    const apiEndPoint = API_URL_UNDERWRITING + "saveUnderWriting";
    const response = await commonApiCall(
      apiEndPoint,
      "post",
      request,
      UNDERWRITING_DETAILS,
      isAuthorized
    );
    if (response.status.code === 200) {
      removeItem("referenceFromUrl");
      const eventObject = {
        agent_id: response?.data?.agentDetail?.agentId,
        application_id: response?.data?.applicationId,
        entry_page: eventPage,
        single_page: false,
      };
      segmentTracking("application_visit", eventObject);
    }
  };

  useEffect(() => {
    if (checkDefault()) {
      saveUnderwriting("MEDICARE");
    }
  }, []);

  useEffect(() => {
    if (checkDefault()) {
      return;
    } else {
      if (!underwriting?.applicationId || !underwriting?.goalType) {
        window.location.replace(CONSUMER_PORTAL_URL + "404");
      }

      if (underwriting && !isEmpty(underwriting.carrierWiseLeads)) {
        const whereToRoute = getProcessStep(
          underwriting.resumeProcess,
          underwriting.goalType,
          underwriting.policyType,
          underwriting.productSelection
        );
        props.history.push(whereToRoute);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      <div className="steps">
        <div className="title-header">
          <h2 className="page-title">{t("medicare.medicare_eroll")}</h2>
          <h4>{t("medicare.medicare_decision_question")}</h4>
        </div>
        <div className="row justify-content-center">
          <div className="col-lg-3 col-sm-6">
            <Animated
              animationIn="fadeInRight"
              animationOut="zoomOut"
              animationInDuration={800}
              animationOutDuration={800}
              isVisible={true}
            >
              <label className="boxmodal-radio">
                <input
                  type="radio"
                  name="medicarePolicyFlag"
                  id="medicarePolicyFlagA"
                  value={true}
                  onChange={(e) => handleChange(e)}
                  onClick={(e) => handleChange(e)}
                />
                <div className="card-inner">
                  <div className="card-img">
                    <svg
                      version="1.1"
                      width="78px"
                      height="78px"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g transform="matrix(1 0 0 1 -505 -420 )">
                        <path
                          d="M 76.53749907016754 42.63354028657854  C 77.02499907743186 40.69565210485986  78 38.27329061435224  78 34.3975142509149  C 78 27.130433677757843  71.17500098794699 24.223601910523556  67.27500092983246 24.223601910523556  C 67.27500092983246 24.223601910523556  56.55000185966492 24.223601910523556  56.55000185966492 24.223601910523556  C 58.50000188872218 19.37888152841884  59.96250187419355 13.565216838878921  58.98750185966492 9.204968610491816  C 56.55000185966492 0.48447215371760605  49.23750185966492 0  46.80000185966492 0  C 46.80000185966492 0  46.3125 0  46.3125 0  C 44.362499970942736 0  43.387499084696174 0.9689440186673746  42.41249907016754 2.422360191052355  C 42.41249907016754 2.422360191052355  37.53749907016754 15.987577029931275  37.53749907016754 15.987577029931275  L 24.375 29  L 0 29  L 0 72  L 24.375 72  C 24.375 72  24.375 67.82608534946596  24.375 67.82608534946596  C 25.350000014528632 67.82608534946596  27.78749907016754 69.27950325445796  30.22499907016754 70.73291942684294  C 36.074999302625656 73.6397517716129  44.362498953938484 78  52.16249907016754 78  C 63.86249953508377 78  67.76249988377094 76.54658296131151  70.6875 71.70186257920679  C 72.15000005811453 68.79503023443684  72.15000092983246 66.37266744447395  72.15000092983246 64.91925127208896  C 73.12500094436109 63.95030718122963  74.58749813307077 62.49689108103661  75.07499814033508 60.07453088998425  C 75.5624981475994 57.6521706989319  75.5624981475994 56.19875741422529  75.07499814033508 54.74534124184031  C 76.04999815486372 53.29192506945533  77.02499813307077 51.354036165817064  77.51249814033508 48.44720382104711  C 77.51249814033508 46.02484362999475  77.02499907743186 44.08695645896351  76.53749907016754 42.63354028657854  Z M 17.0625 60.559004776308875  C 17.0625 63.46583712107884  15.112500116229057 65.4037251584136  12.1875 65.4037251584136  C 9.262499883770943 65.4037251584136  7.3125 63.46583712107884  7.3125 60.559004776308875  C 7.3125 57.65217243153892  9.262499883770943 55.71428439420417  12.1875 55.71428439420417  C 15.112500116229057 55.71428439420417  17.0625 57.65217243153892  17.0625 60.559004776308875  Z M 70.19999814033508 42.14906640025391  C 70.19999814033508 42.14906640025391  71.66249907016754 44.08695732526703  71.66249907016754 44.08695732526703  C 71.66249907016754 44.08695732526703  72.63749814033508 45.055900477630885  72.63749814033508 47.47826066868324  C 72.63749814033508 50.38509301345321  70.6875 51.83850716446332  70.6875 51.83850716446332  C 70.6875 51.83850716446332  69.22499907016754 53.291924203151815  69.22499907016754 53.291924203151815  C 69.22499907016754 53.291924203151815  70.19999814033508 54.74534124184031  70.19999814033508 54.74534124184031  C 70.19999814033508 54.74534124184031  71.17499815486372 56.198756403537864  70.19999814033508 58.136644585256526  C 69.71249813307077 60.07453276697519  67.76249814033508 61.527947928672745  67.76249814033508 61.527947928672745  C 67.76249814033508 61.527947928672745  66.30000185966492 62.98136496736124  66.30000185966492 62.98136496736124  C 66.30000185966492 62.98136496736124  67.27500092983246 64.91925127208896  67.27500092983246 64.91925127208896  C 67.27500092983246 64.91925127208896  68.24999912828207 66.85714219710208  66.78749907016754 69.27950238815444  C 65.81249905563891 71.2173905698731  64.83750092983246 72.67080573157065  52.65000092983246 72.67080573157065  C 45.825001046061516 72.67080573157065  38.0249991863966 68.79503138950818  32.66249907016754 65.88819904473823  C 28.762499012053013 63.95031086301956  26.325000029057264 62.98136496736124  24.375 62.98136496736124  C 24.375 62.98136496736124  24.375 33.91304267473298  24.375 33.91304267473298  C 24.375 33.91304267473298  24.86249953508377 33.91304267473298  24.86249953508377 33.91304267473298  C 25.837499549612403 33.91304267473298  26.81249905563891 33.42857156779878  27.78749907016754 32.944099522369115  C 27.78749907016754 32.944099522369115  41.4375 19.37888152841884  41.4375 19.37888152841884  C 41.925000007264316 18.894409482989175  41.924999062903225 18.409937690231367  42.41249907016754 17.925465644801697  C 42.41249907016754 17.925465644801697  47.28749907016754 4.84472038210471  47.28749907016754 4.84472038210471  C 49.72499907016754 4.84472038210471  53.137501845136285 5.813664112004248  54.11250185966492 10.173912340391354  C 54.60000186692923 13.080744685161314  53.625 17.925465644801697  51.1875 23.73913033434162  C 50.699999992735684 25.192546506726604  50.700001845136285 26.16148908155479  51.67500185966492 27.61490525393977  C 52.16250186692923 28.583849344799102  53.62500087171793 29.068322292628263  55.08750092983246 29.068322292628263  C 55.08750092983246 29.068322292628263  67.27500092983246 29.068322292628263  67.27500092983246 29.068322292628263  C 67.76250093709677 29.068322292628263  73.125 30.037266022527803  73.125 34.3975142509149  C 73.125 38.27329061435224  71.66249907016754 40.211180095526174  71.66249907016754 40.211180095526174  C 71.66249907016754 40.211180095526174  70.19999814033508 42.14906640025391  70.19999814033508 42.14906640025391  Z "
                          fill-rule="nonzero"
                          fill="#2ba84a"
                          stroke="none"
                          transform="matrix(1 0 0 1 505 420 )"
                        />
                      </g>
                    </svg>
                  </div>
                  <h2 className="page-title mb-0">{t("medicare.yes")}</h2>
                </div>
              </label>
            </Animated>
          </div>
          <div className="col-lg-3 col-sm-6">
            <Animated
              animationIn="fadeInRight"
              animationOut="zoomOut"
              animationInDuration={800}
              animationOutDuration={800}
              isVisible={true}
            >
              <label className="boxmodal-radio">
                <input
                  type="radio"
                  name="medicarePolicyFlag"
                  id="medicarePolicyFlag"
                  value={false}
                  onChange={(e) => handleChange(e)}
                  onClick={(e) => handleChange(e)}
                />
                <div className="card-inner">
                  <div className="card-img">
                    <svg
                      version="1.1"
                      width="78px"
                      height="78px"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g transform="matrix(1 0 0 1 -905 -420 )">
                        <path
                          d="M 78 43.38749814033508  C 78 39.97499819844961  77.02500187419355 37.05000098794699  76.05000185966492 35.58750092983246  C 76.53750186692923 34.12500087171793  77.51250093709677 32.17499953508377  77.02500092983246 29.73749953508377  C 77.02500092983246 26.812499418854713  75.56250094436109 24.37500094436109  74.58750092983246 23.40000092983246  C 75.07500093709677 21.93750087171793  75.07500093709677 20.475000232458115  74.58750092983246 18.037500232458115  C 74.10000092256814 15.600000232458115  72.63749908469617 14.137500246986747  71.66249907016754 13.162500232458115  C 72.14999907743186 11.700000174343586  72.14999816939235 9.262499883770943  70.19999814033508 6.337499767541885  C 68.24999811127782 1.4624997675418854  64.35000139474869 0  52.65000092983246 0  C 44.362500697374344 0  36.56249883770943 3.9000000581145287  30.22499907016754 7.3125  C 28.274999041110277 8.287500014528632  25.350000014528632 9.75  24.375 9.75  C 24.375 9.75  0 9.75  0 9.75  L 0 53  L 24.375 53  L 24.375 49.23750185966492  L 37.53749907016754 62.40000092983246  C 37.53749907016754 62.40000092983246  42.41249907016754 76.05000185966492  42.41249907016754 76.05000185966492  C 43.387499084696174 77.02500187419355  44.362499970942736 78  46.3125 78  C 46.3125 78  46.80000185966492 78  46.80000185966492 78  C 49.23750185966492 78  56.549999970942736 77.5125016272068  58.5 68.73750185966492  C 59.47500001452863 64.35000197589397  58.012500029057264 58.01249988377094  56.0625 53.625  C 56.0625 53.625  67.27500092983246 53.625  67.27500092983246 53.625  C 70.68750087171793 53.137499992735684  77.51249999273568 50.69999814033508  78 43.38749814033508  Z M 7.3125 41.4375  C 7.3125 38.51249988377094  9.262499883770943 36.5625  12.1875 36.5625  C 15.112500116229057 36.5625  17.0625 38.51249988377094  17.0625 41.4375  C 17.0625 44.36250011622906  15.112500116229057 46.3125  12.1875 46.3125  C 9.262499883770943 46.3125  7.3125 44.36250011622906  7.3125 41.4375  Z M 73.125 42.90000092983246  C 73.125 48.262501046061516  67.76250093709677 48.75  67.27500092983246 48.75  C 67.27500092983246 48.75  55.08750092983246 48.75  55.08750092983246 48.75  C 53.62500087171793 48.75  52.65000187419355 49.237498082220554  51.67500185966492 50.69999814033508  C 50.700001845136285 51.674998154863715  50.699999992735684 53.13749901205301  51.1875 54.59999907016754  C 53.625 60.449999302625656  54.60000186692923 65.32499988377094  54.11250185966492 68.25  C 53.137501845136285 72.63749988377094  49.72499907016754 73.61250185966492  47.28749907016754 73.61250185966492  C 47.28749907016754 73.61250185966492  42.41249907016754 60.44999814033508  42.41249907016754 60.44999814033508  C 42.41249907016754 59.96249813307077  41.925000007264316 59.47500186692923  41.4375 58.98750185966492  C 41.4375 58.98750185966492  27.29999953508377 44.84999907016754  27.29999953508377 44.84999907016754  C 26.812499527819455 44.362499062903225  25.837499549612403 43.875  24.86249953508377 43.875  C 24.86249953508377 43.875  24.375 43.875  24.375 43.875  C 24.375 43.875  24.375 14.625  24.375 14.625  C 26.325000029057264 14.625  28.2749991863966 13.650000493973494  32.66249907016754 11.70000046491623  C 38.0249991863966 8.775000348687172  45.825001046061516 4.875  52.65000092983246 4.875  C 64.83750092983246 4.875  65.81249905563891 6.825000174343586  66.78749907016754 8.287500232458115  C 68.24999912828207 10.725000232458115  67.27500092983246 12.67499953508377  67.27500092983246 12.67499953508377  C 67.27500092983246 12.67499953508377  66.30000185966492 14.625  66.30000185966492 14.625  C 66.30000185966492 14.625  68.25 16.087499767541885  68.25 16.087499767541885  C 68.25 16.087499767541885  70.19999999273568 17.0625  70.6875 19.5  C 71.17500000726432 21.450000029057264  70.6875 22.91249907016754  70.6875 22.91249907016754  C 70.6875 22.91249907016754  69.22499907016754 24.375  69.22499907016754 24.375  C 69.22499907016754 24.375  70.6875 25.83750092983246  70.6875 25.83750092983246  C 70.6875 25.83750092983246  72.63749814033508 27.299998953938484  72.63749814033508 30.22499907016754  C 72.63749814033508 32.66249907016754  71.66249907016754 33.63750046491623  71.66249907016754 33.63750046491623  C 71.66249907016754 33.63750046491623  69.71250092983246 35.09999907016754  69.71250092983246 35.09999907016754  C 69.71250092983246 35.09999907016754  71.66249907016754 37.04999953508377  71.66249907016754 37.04999953508377  C 71.66249907016754 37.04999953508377  73.61250000726432 39.00000087171793  73.125 42.90000092983246  Z "
                          fill-rule="nonzero"
                          fill="#2ba84a"
                          stroke="none"
                          transform="matrix(1 0 0 1 905 420 )"
                        />
                      </g>
                    </svg>
                  </div>
                  <h2 className="page-title mb-0">{t("medicare.no")}</h2>
                </div>
              </label>
            </Animated>
          </div>
          {checkDefault() ? null : (
            <div className="col-12 text-center mt-3">
              <Link
                to={UnderWritingRoutes.GET_START}
                className="btn btn-link"
                title="Back"
              >
                {t("back")}
              </Link>
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  underwriting: state.underwriting.underwriting,
  company_information: state.underwriting.companyInformation,
  direct_link: state.underwriting.direct_link,
});

export default connect(mapStateToProps, { commonApiCall })(
  withRouter(MedicareEnroll)
);
